import React from 'react'
import { connect } from 'react-redux'
import { toggleDialog } from 'actions/view'
import { IconButton, Tooltip } from '@material-ui/core'
import { bindActionCreators } from 'redux'
import DudeReadingV2Icon from 'components/theme/DudeReadingV2Icon'

const mapDispatchToProps = dispatch =>
  bindActionCreators({ toggleDialog }, dispatch)

const HeaderVastGptButton = ({ toggleDialog }) => {
  return (
    <Tooltip title="VastGPT">
      <IconButton
        style={{
          color: '#fff',
          marginRight: 8,
        }}
        onClick={() => toggleDialog({ open: true, dialog: 'AiKnowledge' })}
      >
        <DudeReadingV2Icon />
      </IconButton>
    </Tooltip>
  )
}

export default connect(null, mapDispatchToProps)(HeaderVastGptButton)
